import { useQuery } from "@tanstack/react-query";
import { getRatingByUId } from "@/modules/lead-page/api/lead-page.v2.api";
import { RatingDetailsResponse } from "@/modules/lead-page/dtos/index-v2";

interface UseRatingDetailsParams {
  ratingUId: string;
  enabled?: boolean;
}

export const useRatingDetails = ({
  ratingUId,
  enabled = true,
}: UseRatingDetailsParams) => {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["leadRatingDetails", ratingUId],
    queryFn: () => getRatingByUId(ratingUId),
    enabled: enabled && !!ratingUId,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  });

  return {
    ratingDetails: data?.data as RatingDetailsResponse | undefined,
    isLoading,
    isError,
    error,
    refetch,
  };
};
